import { AtomMapProvider } from '@atom/map';

import LocationInputs from './LocationInputs';
import PointLocationTabMap from './PointLocationTabMap';

import classes from './pointLocationTab.module.css';

const PointLocationTab = () => {
  return (
    <AtomMapProvider>
      <div className={classes.locationTabContainer}>
        <div>
          <div className={classes.tabTitle}>Location</div>
          <div className={classes.titleSubtext}>
            Provide a location by entering an address, coordinates, or clicking
            directly on the map.
          </div>
          <LocationInputs />
        </div>
        <div className={classes.mapContainer}>
          <PointLocationTabMap />
        </div>
      </div>
    </AtomMapProvider>
  );
};

export default PointLocationTab;
